import { computed, extendObservable, observable, when } from 'mobx';


class Show {
    @observable title;
    @observable url;

    constructor(store, props){
        extendObservable(this, props);
        this.store = store;
        this.disposer = when(
            () => this.store.shows.indexOf(this) === -1,
            () => this.destroy()
        );
    }

    destroy() {
        this.disposer();
        this.disposer = null;
        this.store = null;
    }

    @computed get firstLetter() {
        const firstLetter = this.sortableTitle.substring(0, 1).toUpperCase();
        return firstLetter.match(/^[^a-z]/i) ? '#' : firstLetter;
    }

    @computed get sortableTitle() {
        return this.title.replace(/^(the|a)\s+/i, '');
    }

}


export default Show;



// WEBPACK FOOTER //
// ./src/show-index/models/show.js